module.exports = __webpack_public_path__ + "img/ev.b8f19b21.png";